import {useCallback, useState} from "react";
import clsMerge from "./clsMerge";

const useFakeLoading = (delayMs = 300) => {
	const [isLoading, setIsLoading] = useState(false);
	const triggerLoading = useCallback(() => {
		setIsLoading(true);
		setTimeout(() => {
			setIsLoading(false);
		}, delayMs);
	}, [delayMs]);
	const opacityLoadingClassName = clsMerge(
		"transition-opacity opacity-100",
		isLoading && "opacity-60 pointer-events-none"
	);
	return {isLoading, triggerLoading, opacityLoadingClassName};
};

export default useFakeLoading;
